module.exports = __webpack_public_path__ + "img/fund-logo.d786fbf1.png";